import React, { useState } from 'react';
import authService from '../services/authService'; // Adjust path as needed
import logo from '../Mantle Logo.png';

const Logout = ({ onLogout }) => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleLogout = async (e) => {
    e.preventDefault(); 
    
    try {
      // authService.logout() clears all local storage session data 
      // (except dbName) and pings the backend.
      await authService.logout();
      
      setError('');
      setSuccess('Logout successful. Please wait to be redirected.');
      
      onLogout(); // Notify parent components
      window.location.href = "/login";
      
    } catch (err) {
      setError("Failed to log out completely. " + err.message);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-slate-50 font-sans">
      <div className="w-full max-w-[500px] bg-white p-10 rounded-lg shadow-md border border-slate-200">
        
        {/* Branding */}
        <div className="text-center mb-8">
          <img 
            src={logo}
            alt="Mantle Logo"
            className="h-8 w-auto mx-auto" 
          />
          <p className="mt-1.5 text-slate-500 text-sm">
            Please click the button to log out of your workspace.
          </p>
        </div>

        <form onSubmit={handleLogout} className="flex flex-col gap-5">

          {/* Error Message */}
          {error && (
            <div className="text-red-600 text-[0.85rem] text-center">
              {error}
            </div>
          )}
          
          {/* Success Message */}
          {success && (
            <div className="text-green-600 text-[0.85rem] text-center">
              {success}
            </div>
          )}

          {/* Submit Button */}
          <button 
            type="submit"
            className="mt-2.5 p-3 bg-slate-900 text-white border-none rounded text-base font-semibold cursor-pointer transition-colors hover:bg-slate-800"
          >
            Log Out
          </button>
        </form>
      </div>
    </div>
  );
};

export default Logout;